/**
 * The timecard page headers' outlined button, as those headers have always drawn it: white with a
 * grey-300 outline, a 13px semibold label and 13px side padding, turning green on hover. Passed as the
 * extra class to `buttonStyle({ variant: 'outlined' })`, whose kit outline is grey-filled, medium weight
 * and narrower.
 */
export const WHITE_OUTLINED_CLASS =
    'bg-paper border-grey-300 px-[13px] text-[13px] font-semibold hover:bg-paper hover:border-primary hover:text-primary';
